module.exports = __webpack_public_path__ + "img/telegram.a65795cf.svg";